'use client';
import { motion } from 'motion/react';
import React from 'react';

import { Slider } from '@/components/Slider';
import { useLocale } from '@/contexts/LocaleContext';
import { Blog } from '@/payload-types';
import { cn } from '@/utils/cn';
import { getDictionary } from '@/utils/getDictionary';

import { BlogCard } from '../BlogCard';
import styles from './BlogSlider.module.scss';

type Props = {
  cards: Blog[];
  title?: string;
};

const cardVariants = {
  hidden: { opacity: 0, y: 50 },
  visible: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: 50 },
};

export const BlogSlider: React.FC<Props> = ({ cards, title }) => {
  const locale = useLocale();
  const t = getDictionary(locale);

  if (!cards || cards.length === 0) {
    return null;
  }

  return (
    <div className={cn('container', styles.wrapper)}>
      <Slider title={title || t('blog.latestArticles')} label={t('blog.name')}>
        {cards.map((card) => (
          <motion.div
            key={`BlogSliderCard-${card.id}`}
            variants={cardVariants}
            style={{ willChange: 'transform, opacity' }}
            transition={{ duration: 0.3 }}
            className={cn(styles.slide)}
          >
            <BlogCard className={styles.card} {...card} disableParallax />
          </motion.div>
        ))}
      </Slider>
    </div>
  );
};
